import type { ContentPage } from "@/lib/content/types";

// CRM › CRM Analytics › Funnels (leaf).
export const funnels: ContentPage = {
  slug: "crm-analytics/funnels",
  template: "hrmsFeature",
  seo: {
    title: "Sales Funnel Analysis - Find & Fix Pipeline Leaks | GetBiz CRM",
    description: "Analyze your sales funnel in GetBiz CRM to see stage-by-stage conversion and find exactly where deals leak, so you can fix bottlenecks.",
    keywords: ["sales funnel analysis", "crm funnel", "pipeline conversion", "funnel reporting"],
    ogImage: "/assets/data/seoimages/funnels.webp",
  },
  leaf: {
    hero: {
      caption: "Funnels",
      title: "See Exactly Where Deals Convert and Leak",
      description: "Visualize your pipeline as a funnel to find the stages where deals stall, so you know precisely where to improve.",
      h1: "caption",
    },
    split: {
      title: "Why Teams Choose Funnels",
      bullets: [
        { title: "Stage Conversion", description: "See the conversion rate between every pipeline stage." },
        { title: "Spot Bottlenecks", description: "Instantly find the stage where deals stall." },
        { title: "Segment Funnels", description: "Compare funnels by source, rep or product." },
        { title: "Time in Stage", description: "See how long deals sit at each step." },
      ],
      image: "/assets/images/img/product/crm/funnels-lead-image.webp",
      imageAlt: "Funnels — GetBiz CRM",
    },
    cardsHeading: {
      title: "Works With the Rest of CRM Analytics",
      description: "Funnels connects to every other part of CRM Analytics in GetBiz CRM.",
    },
    cards: [
      { title: "Reports", href: "/crm-software/crm-analytics/reports/", description: "Create, filter and schedule reports on leads, deals, activity and revenue.", image: "/assets/images/img/product/crm/reports.webp", imageAlt: "GetBiz CRM reports" },
      { title: "Charts", href: "/crm-software/crm-analytics/charts/", description: "Turn any report into clear bar, line, pie or funnel charts so trends and outliers jump out instantly.", image: "/assets/images/img/product/crm/charts.webp", imageAlt: "GetBiz CRM charts" },
      { title: "Cohorts", href: "/crm-software/crm-analytics/cohorts/", description: "Group leads and customers into cohorts to see how conversion, retention and value change across segments and time.", image: "/assets/images/img/product/crm/cohorts.webp", imageAlt: "GetBiz CRM cohorts" },
      { title: "KPIs", href: "/crm-software/crm-analytics/kpis/", description: "Set targets and monitor sales KPIs.", image: "/assets/images/img/product/crm/kpis.webp", imageAlt: "GetBiz CRM kpis" },
    ],
    testimonials: {
      title: "Businesses across India love & trust GetBiz!",
      description: "See why teams choose GetBiz CRM to run their sales.",
    },
    bookDemoTitle: "See Funnels in action.",
    relatedBlogs: "static",
    metaKey: "crm-analytics-funnels",
  },
  sections: [],
};
